<template>
  <div>

        <input type="text" v-bind:value="value" v-on:focus="focus($event)" v-on:blur="blur()" @input="search($event)" v-on:keyup.enter="enter($event)" :placeholder="placeholder">

      <div class="live-search" v-if="open&&items.length">
          <div class="live-search__contents">
              <span v-bind:key="item.id" v-for="item in items">
                  <div class="result" v-on:mousedown="click($event, item)" v-if="item.article_type!='auto'">

                      {{renderItem(item)}}

                      <i class="material-icons">add</i>
                  </div>
                  <div v-if="item.article_type=='auto'" class="result result--auto">

                      {{renderItem(item)}}

                      <span>(auto)</span>
                  </div>
              </span>
          </div>
      </div>
      </div>
</template>

<script>
    export default {
        props: ['value', 'matchingItems', 'displayProperty', 'placeholder'],
        data () {
            return {
              items: [],
              open: false
            }
        },
        computed: {
        },
        methods: {
            click ($event, item) {
                $event.preventDefault();
                this.$emit('input', item.name)
                this.$emit('clickResult', item)
                this.open = false;
            },
            blur () {
              this.open = false;
            },
            search ($e) {
              this.open = true
              this.items = this.matchingItems($e.target.value);
              this.$emit('input', $e.target.value)
            },
            enter($e) {
                this.$emit('enterResult', $e.target.value)
                this.open = false;
            },
            renderItem (item){
              if(this.displayProperty){
                return item[this.displayProperty]
              }
              return item.name;
            },
            focus ($e) {
              this.open = true;
              this.items = this.matchingItems($e.target.value);
            },
        },
    }
</script>
